import { Flex, styled } from '@shared/components';

const SectionWrapper = styled(Flex)(({ theme }) => ({
  flexDirection: 'column',
  gap: theme.spacing(4),
}));

export default SectionWrapper;
